export enum DefaultPortalRoute {
	Login = "PortalLogin",
	Register = "PortalRegister",
}
